"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllStates = exports.getStatesUsingScroll = void 0;
const tslib_1 = require("tslib");
const uniqBy_1 = tslib_1.__importDefault(require("lodash/uniqBy"));
const __elasticsearch_1 = require("../../../__elasticsearch");
const ElasticsearchEnums_1 = require("../../../__types/__enums/ElasticsearchEnums");
const parseElasticsearchResult_1 = require("../../__common/parseElasticsearchResult");
const getStateData_1 = require("../__common/getStateData");
function getStatesUsingScroll(scrollId, elasticsearchClient) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const result = yield elasticsearchClient.scroll({ scrollId, scroll: '1m' });
        return parseElasticsearchResult_1.parseUserContentMetricsResult(result);
    });
}
exports.getStatesUsingScroll = getStatesUsingScroll;
function getAllStates(input) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const { query, projection, sortParams, size } = input;
        const elasticsearchClient = yield __elasticsearch_1.getElasticsearchClient(ElasticsearchEnums_1.ElasticsearchIndicesUrlMapping.state);
        // Fetching the first batch of metrics using query and getting scrollIds
        const elasticsearchResult = yield getStateData_1.getStateData({
            queryInput: {
                size,
                _source: projection,
                body: { query }
            },
            scroll: '5m',
            sortParams
        }, elasticsearchClient);
        // Fetching remaing batch of metrics using scroll
        const { scrollId, total } = elasticsearchResult;
        let { userContentMetrics } = elasticsearchResult;
        let remainingDocs = total - userContentMetrics.length;
        if (scrollId && remainingDocs > 0) {
            let currentElasticsearchResult;
            do {
                currentElasticsearchResult = yield getStatesUsingScroll(scrollId, elasticsearchClient);
                const currentUserContentMetrics = currentElasticsearchResult.userContentMetrics;
                remainingDocs -= currentUserContentMetrics.length;
                userContentMetrics = userContentMetrics.concat(currentUserContentMetrics);
            } while (remainingDocs > 0);
        }
        return { total, userContentMetrics: uniqBy_1.default(userContentMetrics, '_id') };
    });
}
exports.getAllStates = getAllStates;
//# sourceMappingURL=getAllStates.js.map